/**
 * Labstep
 *
 * @module components/EntityUser/List
 * @desc List of EntityUser
 */

import { EntityUserAvatar } from 'labstep-web/components/EntityUser/Avatar';
import { Flex } from 'labstep-web/core/Flex';
import { PlusCount } from 'labstep-web/core/List/Cap';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntityUserListProps } from './types';

export const EntityUserList: React.FC<EntityUserListProps> = ({
  entity,
  onPlusCountClick,
  hidePopup,
  entityUserRoleName,
}) => (
  <Flex className={styles.container}>
    {entity.entity_users_preview
      .filter((entityUser) => entityUser?.user?.name)
      .filter((entityUser) =>
        entityUserRoleName
          ? entityUser.entity_user_role?.name === entityUserRoleName
          : true,
      )
      .map((entityUser) => (
        <EntityUserAvatar
          popup={!hidePopup}
          content={`${entityUser.user.name} - ${entityUser.getRole(
            entity.author,
          )}`}
          key={entityUser.id}
          entityUser={entityUser}
          showName={!!entityUserRoleName}
        />
      ))}
    {!entityUserRoleName && (
      <PlusCount
        onClick={onPlusCountClick}
        count={
          entity.entity_users_count -
          entity.entity_users_preview.length
        }
        circular
      />
    )}
  </Flex>
);
